module.exports = __webpack_public_path__ + "static/media/case.7e62d01c.png";